export const capitalize = (value: string) => {
  if (!value) return '';
  return (
      value
      .toString()
      .charAt(0)
      .toUpperCase() + value.slice(1)
  );
};

export const toSimpleDateFormat = (value: string) => {
  if (!value) return '';
  const months = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  const date = new Date(value);
  const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  return (
      date.getDate() + ' ' +
      months[date.getMonth()] + '. ' +
      date.getFullYear() + ' ' +
      date.getHours() + ':' +
      minutes
  );
};
